class InvalidProxyRouteError extends Error {
  constructor(endpoint) {
    super();
    // Try and be useful here, and try *helping* the user by printing out suggested valid routes.
    this.message = `Cannot whitelist ${endpoint}. See core-utils for more details.`;
  }
}

module.exports = InvalidProxyRouteError;
